import { createStyles } from "@mantine/styles";

export const useStyle = createStyles((theme) => ({
  stepContent: {
    width: "100%",
    maxWidth: "800px",
    padding: theme.spacing.lg,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.md,
    minHeight: "auto",
  },
  headinfo: {
    marginTop: "10px",
    marginLeft: "10px",
    fontSize: "14px",
    fontWeight: 400,
  },

  topDiv: {
    marginTop: "50px",
    width: "80%",
  },
  buttonDiv2: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: "0px",
    marginTop: "80px",
    gap: "40px",
  },
  buttonWrapper: {
    marginTop: theme.spacing.md,
    display: "flex",
    justifyContent: "center",
  },
  buttonRow: {
    marginTop: theme.spacing.md,
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },
  upload: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    alignItems: "center",
    marginBottom: "10px",
  },
  errorSummary: {
    backgroundColor: "#ffe6e6",
    padding: theme.spacing.md,
    marginBottom: theme.spacing.md,
    border: "1px solid red",
    borderRadius: theme.radius.sm,
  },
  tabError: {
    borderBottom: "2px solid red",
    color: "red",
  },
  inputError: {
    border: "1px solid red",
  },
  errorMessage: {
    color: "red",
    fontSize: theme.fontSizes.sm,
    marginTop: theme.spacing.xs,
  },
  modalTitle: {
    fontWeight: 500,
    fontSize: "16px",
    padding: "7px",
  },
  modalHeader: {
    backgroundColor: "#ebeceb",
  },
}));
